import { Typography, FormLabel } from '@mui/material';
import { Button } from '@progress/kendo-react-buttons';
import { Grid } from '@progress/kendo-react-grid';
import styled from 'styled-components';
import { borderGrey, labelGrey, phoneOnlyMaxWidth, tabletPortraitMinWidth, textGrey } from './cssConstants';

export const SubTitleSection = styled.h4`
	font-size: 14px;
	line-height: 17px;
	font-weight: 400;
	margin: 10px auto 10px 0;
	color: ${textGrey};
`;

export const GridButton = styled(Button)`
	color: ${(props) => props.theme.brandingColourHeavy};
	border-color: ${(props) => props.theme.brandingColourHeavy};
	transition: all 0.5s ease;
	font-size: 16px;
	line-height: 26px;

	&:focus {
		box-shadow: none;
	}
`;

export const Paragraph = styled(Typography)`
	line-height: 19px;
`;

export const PromptButtonsWrapper = styled.div`
	display: flex;
	justify-content: space-between;
`;

export const FieldLabel = styled(FormLabel)`
	display: block;
	font-size: 18px;
	line-height: 21px;
	color: ${labelGrey};
	margin: 6px 0;
	position: relative;
	max-width: 100%;
	transform: none;
	white-space: initial;
`;

export const StyledGrid = styled(Grid)`
	margin: 15px 0 40px 0;
	border-color: ${borderGrey};
	border-left: none;
	border-right: none;
	color: ${textGrey};
	width: 100% !important;

	@media (max-width: ${phoneOnlyMaxWidth}) {
		border-bottom: none;
	}

	.k-grid-toolbar {
		background: none;
		padding-left: 0;
	}

	.k-grid-header {
		background: none;
		padding-right: 0;

		@media (max-width: ${phoneOnlyMaxWidth}) {
			display: none;
		}

		.k-grid-header-wrap {
			border: none;
		}
	}

	.k-grid-container {
		.k-grid-content {
			overflow: inherit;
		}
	}

	.k-grid-footer {
		background: none;
		padding-right: 0;

		.k-grid-footer-wrap {
			border: none;
		}
	}

	tr {
		background: none !important;

		&:not(:last-child) {
			td {
				border-bottom: 1px solid ${borderGrey};
			}
		}
	}

	th,
	td {
		border-left: none;

		&:first-child {
			padding-left: 0;
		}

		&:last-child {
			padding-right: 0;
		}
	}

	td {
		font-size: 16px;
	}
`;

export const RightAlignedButtonWrapper = styled.div`
	display: flex;
`;

export const FieldSet = styled.fieldset`
	margin: 0 0 50px 0;
	padding: 0;
	width: 100%;
	border: none;
	min-inline-size: auto; // To fix Kendo file field files list width overflow issue.

	> div {
		@media (min-width: ${tabletPortraitMinWidth}) {
			width: calc(50% - 10px);

			&:nth-child(odd) {
				margin-right: 20px;
			}
		}
	}
`;
